import { useSelector } from 'react-redux';
import { SubmissionSectionSummaryV3 } from '@module/form-components';
import { useCallback, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var SectionSummaryContainer = function SectionSummaryContainer(_ref) {
  var _page$selectedSection;

  var onCancelPin = _ref.onCancelPin,
      readonly = _ref.readonly,
      labels = _ref.labels,
      updateSelectedSection = _ref.updateSelectedSection,
      onSelectQuestion = _ref.onSelectQuestion;
  // Selectors
  var page = useSelector(function (state) {
    return state.formPreviewApp;
  });
  var questions = useMemo(function () {
    var _page$questions;

    return (_page$questions = page === null || page === void 0 ? void 0 : page.questions) !== null && _page$questions !== void 0 ? _page$questions : [];
  }, [page === null || page === void 0 ? void 0 : page.questions]);
  var isLoadingQuestions = !(page !== null && page !== void 0 && page.error) && (Boolean((page === null || page === void 0 ? void 0 : page.isLoadingForm) || (page === null || page === void 0 ? void 0 : page.isLoadingQuestions)) || !(page !== null && page !== void 0 && page.form) || !(page !== null && page !== void 0 && page.questions));
  var selectedSectionIndex = (_page$selectedSection = page === null || page === void 0 ? void 0 : page.selectedSectionIndex) !== null && _page$selectedSection !== void 0 ? _page$selectedSection : 0;
  var sectionSummaries = useMemo(function () {
    var _page$sectionSummarie;

    return (_page$sectionSummarie = page === null || page === void 0 ? void 0 : page.sectionSummaries) !== null && _page$sectionSummarie !== void 0 ? _page$sectionSummarie : [];
  }, [page === null || page === void 0 ? void 0 : page.sectionSummaries]);
  var handleSelectQuestion = useCallback(function (_sectionIndex, questionId, sectionId) {
    var question = questions.find(function (item) {
      return item.id.toString() === questionId;
    });
    var targetSection = sectionSummaries.find(function (section) {
      var _question$sectionId$t, _question$sectionId;

      return section.id.toString() === ((_question$sectionId$t = question === null || question === void 0 ? void 0 : (_question$sectionId = question.sectionId) === null || _question$sectionId === void 0 ? void 0 : _question$sectionId.toString()) !== null && _question$sectionId$t !== void 0 ? _question$sectionId$t : sectionId);
    });
    if (!targetSection) return;
    onCancelPin === null || onCancelPin === void 0 ? void 0 : onCancelPin();
    if (question) onSelectQuestion(question.id.toString());
    updateSelectedSection(targetSection);
    var targetId = questionId ? questionId : "preview-section-".concat(targetSection.id.toString());
    requestAnimationFrame(function () {
      var _document$getElementB;

      (_document$getElementB = document.getElementById(targetId)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  }, [questions, sectionSummaries, updateSelectedSection, onCancelPin, onSelectQuestion]);
  return /*#__PURE__*/_jsx(SubmissionSectionSummaryV3, {
    selectedSectionIndex: selectedSectionIndex,
    sectionSummaries: sectionSummaries,
    label: labels,
    readonly: readonly,
    questionReleases: questions,
    isLoadingGetQuestions: isLoadingQuestions,
    onSelectQuestion: handleSelectQuestion,
    shouldAutoSelectFirstQuestion: false
  });
};